import { Suspense } from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import { usePermission } from "@ip-hooks";
import { Page } from "@ip-partials";
import { Loader } from "@ip-widgets";

import routes from "../Routes";
import Accounting from "./Accounting";
import General from "./General";
import Legal from "./Legal";
import Me from "./Me";
import SecurityAndLogin from "./SecurityAndLogin";
import OtpEnrollment from "./mfa/OtpEnrollment";
import PushEnrollment from "./mfa/PushEnrollment";
import SMSEnrollment from "./mfa/SMSEnrollment";
import VoiceEnrollment from "./mfa/VoiceEnrollment";

export default function Pages() {
  const { hasPermission } = usePermission();
  const route = routes.find((r) => hasPermission(r.path));
  const defaultPath = route?.path || "";

  return (
    <Suspense fallback={<Loader loading={true} />}>
      <Switch>
        {defaultPath && <Redirect exact from="/" to={defaultPath} />}

        <Route component={Accounting} path={"/accounting"} />
        <Route component={Me} path={"/me"} />
        <Route component={Legal} path={"/legal"} />

        <Route component={General} path={"/settings"} />
        <Route component={SecurityAndLogin} path={"/security"} />
        <Route component={OtpEnrollment} path={"/mfa-otp-enrollment"} />
        <Route component={SMSEnrollment} path={"/mfa-sms-enrollment"} />
        <Route component={VoiceEnrollment} path={"/mfa-voice-enrollment"} />
        <Route component={PushEnrollment} path={"/mfa-push-enrollment"} />
        <Route component={Page.Error} path="*" />
      </Switch>
    </Suspense>
  );
}
